<template>
  <td>
    <button class="k-primary k-button k-grid-edit-command m-1" @click="editHandler">Edit</button>
    <button class="k-button k-grid-remove-command m-1" @click="removeHandler">Remove</button>
    <button  
      type="button" class="k-button k-grid-remove-command"
       @click="auditHandler" v-b-toggle.sidebar-right >
       <span class="nt-clock"></span>
       </button >
  </td>
</template>
 
<script>
export default {
  props: {
    dataItem: Object,
    columnIndex: Number
  },
  watch: {
    dataItem: function(newVal) {
      this.item = newVal;
    }
  },
  methods: {
    editHandler: function() {
      console.log("edit",this.item)
      this.$emit("edit", { dataItem: this.item });
    },
    removeHandler: function() {
      this.$emit("remove", { dataItem: this.item });
    },
    auditHandler:function () {
      console.log("entered")
      this.$emit("audit", { dataItem: this.item });
    }
  },
  data: function() {
    return {
      item: { ...this.dataItem }
    };
  }
};
</script>
 
<style>
</style>
